/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

export const LOADING_CONFIG = {
  // Messages for Step 1: Uploading
  upload: {
    phone: [
      "💡 Mẹo: Ảnh có độ tương phản cao sẽ in đẹp hơn.",
      "✨ AI đang tối ưu hóa độ phân giải cho bản in sắc nét...",
      "🎨 Dùng ảnh PNG trong suốt để phối màu ốp tốt nhất.",
      "🚀 Đang nén ảnh để upload nhanh hơn...",
      "☀️ Đừng lo nếu ảnh hơi tối, chúng tôi sẽ tự động cân bằng sáng."
    ],
    cup: [
      "💡 Mẹo: Logo dạng vector (PNG trong suốt) cho kết quả laser tốt nhất.",
      "✨ Đang xử lý logo để mô phỏng hiệu ứng khắc laser...",
      "🎨 Logo sẽ được chuyển sang màu vàng/gold đặc trưng.",
      "🚀 Đang tối ưu dung lượng ảnh...",
      "🔧 AI đang làm nét các đường viền mảnh của logo."
    ]
  },
  
  // Messages for Step 3: Mockup Generation (when selecting a case/cup)
  mockup: {
    phone: [
      "📱 Đang ướm thử thiết kế của bạn lên ốp lưng...",
      "✨ AI đang tính toán độ phản chiếu ánh sáng trên bề mặt ốp...",
      "🎨 Đang căn chỉnh màu sắc để giống thực tế nhất...",
      "🛠️ Đang mô phỏng kết cấu in UV chất lượng cao...",
      "☕ Sắp xong rồi! Một tách cafe và bản thiết kế sẽ hiện ra."
    ],
    cup: [
      "☕ Đang khắc laser logo của bạn lên bề mặt cốc...",
      "✨ AI đang tạo hiệu ứng ánh kim màu vàng/gold...",
      "🎨 Đang mô phỏng độ nhám tự nhiên của bã cà phê...",
      "🔍 Đang căn chỉnh vị trí logo chuẩn xác nhất...",
      "🚀 Hệ thống đang dựng mô hình 3D cho cốc của bạn."
    ]
  }
};

export type LoadingCategory = keyof typeof LOADING_CONFIG;
export type LoadingProductMode = 'phone' | 'cup';
